import React from 'react';
import type { PageTemplate } from '@packages/recommendations/src/types';
import { PrudsysBasketProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/PrudsysBasketProductsRecoSlider/PrudsysBasketProductsRecoSlider.client';
import { SearchBasketToProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SearchBasketToProductsRecoSlider/SearchBasketToProductsRecoSlider.client';
import { SearchTopsellerProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SearchTopsellerProductsRecoSlider/SearchTopsellerProductsRecoSlider.client';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  productRecSliderHeadline: {
    id: 'CheckoutContainer.Basket.ProductRec.Headline',
    defaultMessage: 'Empfehlungen für Sie',
  },
});

const providerComponentMap = {
  empiriecom: {
    empty: SearchTopsellerProductsRecoSlider,
    filled: SearchBasketToProductsRecoSlider,
  },
  prudsys: {
    empty: PrudsysBasketProductsRecoSlider,
    filled: PrudsysBasketProductsRecoSlider,
  },
};

export const BasketWishlistRecommendation = ({
  pageTemplate,
  productIds,
  aklIds,
}: {
  pageTemplate: PageTemplate;
  productIds: string[];
  aklIds: string[];
}) => {
  const { formatMessage } = useIntl();
  const {
    recommendations: { provider },
  } = useConfig();

  const RecoSlider = providerComponentMap[provider][aklIds.length ? 'filled' : 'empty'];
  return (
    <RecoSlider
      pageTemplate={pageTemplate}
      preferTitle
      title={formatMessage(messages.productRecSliderHeadline)}
      fetchOnThreshold
      productIds={productIds}
      aklIds={aklIds}
      elementIndex={0}
    />
  );
};
